(() => {
  class HxDeliveryWindow extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.update();
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.update();
      }, {signal: this.controller.signal});
      this.timer = setInterval(() => this.update(), 60000);
    }
    update() {
      const dates = this.querySelector('[data-delivery-dates]');
      if (!dates) return;
      const start = new Date(Date.now() + 86400000);
      const end = new Date(Date.now() + 345600000);
      const options = {day: 'numeric', month: 'short', timeZone: this.dataset.timeZone || 'Europe/Paris'};
      let format;
      try { format = new Intl.DateTimeFormat(this.dataset.locale || document.documentElement.lang || 'fr', options); }
      catch { format = new Intl.DateTimeFormat('fr', options); }
      const label = format.formatRange ? format.formatRange(start, end) : format.format(start) + ' – ' + format.format(end);
      if (dates.textContent !== label) dates.textContent = label;
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      clearInterval(this.timer);
    }
  }
  if (!customElements.get('hx-delivery-window')) customElements.define('hx-delivery-window', HxDeliveryWindow);
  class HxCartSuggestions extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.querySelector('.hx-cart-upsell-controls').hidden = false;
      this.addEventListener('click', event => {
        const control = event.target.closest('[data-upsell-scroll]');
        if (!control) return;
        const track = this.querySelector('.hx-cart-upsells-track'), direction = Number(control.dataset.upsellScroll);
        const step = track.querySelector('article').getBoundingClientRect().width + 12;
        const edge = track.scrollWidth - track.clientWidth;
        const left = direction > 0 && track.scrollLeft >= edge - 2 ? 0 : direction < 0 && track.scrollLeft <= 2 ? edge : track.scrollLeft + direction * step;
        track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
      },{signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  }
  if (!customElements.get('hx-cart-suggestions')) customElements.define('hx-cart-suggestions',HxCartSuggestions);
  class HxCartQuickAdd extends HTMLElement {
    static busy = false;
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', event => { event.preventDefault(); this.add(); }, {signal:this.controller.signal});
    }
    async add() {
      const Type = this.constructor, drawer = document.querySelector('arte-cart-drawer'), Page = customElements.get('arte-cart-page'), Subscription = customElements.get('arte-cart-subscription');
      if (Type.busy || drawer?.busy || Page?.busy || Subscription?.busy || !this.form.reportValidity()) return;
      const payload = new FormData(this.form), page = document.querySelector('arte-cart-page'), inDrawer = !!this.closest('arte-cart-drawer');
      const sections = [drawer?.dataset.section, page?.dataset.cartSection].filter(Boolean);
      payload.delete('selling_plan');
      payload.set('sections', sections.join(',')); payload.set('sections_url', location.pathname);
      Type.busy = true; if (Page) Page.busy = true;
      drawer?.lock(true); page?.setAttribute('aria-busy','true');
      const controls = [...(page?.querySelectorAll('button,input') || [])].map(node => [node,node.disabled]);
      controls.forEach(([node]) => node.disabled = true);
      this.form.setAttribute('aria-busy','true');
      const button = this.querySelector('button'); button.disabled = true;
      const status = this.querySelector('[data-upsell-status]'); status.textContent = this.dataset.pending;
      let confirmed = false;
      try {
        const response = await fetch(this.dataset.add,{method:'POST',headers:{Accept:'application/json'},body:payload});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        confirmed = true;
        const pageRendered = Page?.renderSections(result.sections), drawerRendered = drawer?.renderCart(result.sections);
        if ((page && !pageRendered) || (drawer && !drawerRendered)) { window.location.assign(this.dataset.cart); return; }
        if (inDrawer) {
          drawer.status(this.dataset.success,false,'success');
          drawer.querySelector('.hx-cart-upsells button, [data-v3-close]')?.focus({preventScroll:true});
        } else {
          const nextPage = document.querySelector('arte-cart-page'), message = nextPage?.querySelector('[data-cart-page-status]');
          if (message) { message.textContent = this.dataset.success; message.dataset.state = 'success'; message.tabIndex = -1; message.focus({preventScroll:true}); }
        }
      } catch (error) {
        if (confirmed) { window.location.assign(this.dataset.cart); return; }
        status.textContent = error.message === 'Failed to fetch' ? this.dataset.error : (error.message || this.dataset.error);
        this.querySelector('[data-upsell-recover]').hidden = false;
      } finally {
        Type.busy = false; if (Page) Page.busy = false;
        drawer?.lock(false); document.querySelector('arte-cart-page')?.removeAttribute('aria-busy');
        controls.forEach(([node,disabled]) => { if (node.isConnected) node.disabled = disabled; });
        button.disabled = false; this.form.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  }
  if (!customElements.get('hx-cart-quick-add')) customElements.define('hx-cart-quick-add',HxCartQuickAdd);
})();
